import React, { Component, Fragment } from 'react';
import { CustomLoading, Loading } from './LoadingComponent';
import { connect } from 'react-redux';
import { Breadcrumb, BreadcrumbItem, Label, Input, Button, Form, FormGroup, Alert,
         Modal, ModalHeader, ModalBody, ButtonGroup } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { Control, Form as ReduxForm  } from 'react-redux-form';
import { CSVLink } from "react-csv";
import { aggregate, sort_by, CustomListSelect,
         add_perc_key, transpose } from './Functions';
import { RenderVirtualTable } from './TableComponent';
import { port_tactical_actions } from '../redux/ActionType';
import { BarPlot, MultBarPlot, ScatterPlot, MultLineTsPlot } from './PlotComponent';
import { postRequest } from '../redux/ActionCreators';
import { colors_sura } from '../shared/data';

// import { Auth } from 'aws-amplify';
const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
    tactical_params: state.tactical_params,
    port_metrics_tactical: state.port_metrics_tactical,
  };
};

class PortTactical extends Component {
  constructor(props){
      super(props);
      this.state = {
        load_portfolio:false,
        loading_portfolio:false,
        saving_portfolio:false,
        port_id:'Portafolio',
        show_fx:true,
        msg:null,
        msg_save:null,
        risk_dev:0,
        fund_sel_ow:null,
        fund_sel_uw:null,
        show_series:false
      };
      this.header = this.header.bind(this);
      this.queryPortfolio = this.queryPortfolio.bind(this);
      this.addTrade = this.addTrade.bind(this);
      this.addTrade = this.addTrade.bind(this);
      this.resetTrades = this.resetTrades.bind(this);
      this.sendTrades = this.sendTrades.bind(this);
      this.openSaveModal = this.openSaveModal.bind(this);
      this.savePortfolio = this.savePortfolio.bind(this);
  }
   _isMounted = false;
  
    componentDidMount() {
      this._isMounted = true;
    }
  
    componentWillUnmount() {
      this._isMounted = false;
    }    
    async queryPortfolio(){
      console.log("query portfolio.");
      this.setState({loading_portfolio:true});
      await this.props.changeModel("tactical_params.funds", null);
      try {
        const port_saa = await postRequest({
          port_id:this.props.tactical_params.port_name, 
          last_update:true,
          res_url:false,
          own_only:this.props.user_wm.data?.role==3 ? true : false,
          port_groups:this.props.user_wm.data?.port_groups
        }, 'port_saa');
        if (port_saa.data.length>0){
          await this.props.changeModel("tactical_params.port", port_saa.data.map(item=>{
            return {Asset:item.Asset, Weight:item.Weight*100};
          }));
        }else{
          this.setState({msg:"No hay información del portafolio seleccionado."});
        }
        await this.props.resetModel("port_metrics_tactical");
        this.setState({loading_portfolio:false});
      } catch(error) {
        console.log(error.message);
        this.setState({
          msg:error.message,
          loading_portfolio:false
        });
      }
    }

    openSaveModal(){
      if (this.props.tactical_params.port==null) {
        this.setState({msg:'No se ha cargado ningún portafolio'});
      } else {
        this.setState({load_portfolio:true});
      }
    }
    
  
    async savePortfolio(){
      if (this._isMounted) this.setState({ saving_portfolio: true });
      console.log("Saving portfolio!");
      try {
        const save_port = await postRequest(
            { 
              ref_date:(new Date()).toISOString().slice(0,10),
              port_name:this.props.tactical_params.port_name.includes("Tactico") ? this.props.tactical_params.port_name : this.props.tactical_params.port_name + " - Tactico",
              weights: (this.props.tactical_params.trades.length==0 ? this.props.tactical_params.port : aggregate([...this.props.tactical_params.trades, ...this.props.tactical_params.port], ['Asset'], ['Weight'])).map(item=>{
                return {...item, Weight:item.Weight/100}
              })
            }, 'load_portfolio');
        if (save_port.status=="ok"){
          console.log("adding portfolio to list");
          await this.props.addPort(this.props.tactical_params.port_name.includes("Tactico") ? this.props.tactical_params.port_name : this.props.tactical_params.port_name + " - Tactico");
        }
        console.log(save_port);
        this.setState({
          saving_portfolio:false,
          msg_save: save_port.msg
        });
      } catch (error) {
        this.setState({
          saving_portfolio:false,
          msg_save: error.message
        });
      }
    }
    
    header(){
      return (
        <>
          <div className="row mt-5 justify-content-center">
            <div className="col-md-8">
              <h4>Análisis Táctico</h4>
            </div>  
          </div>
          <div className="row mt-2 justify-content-center">
            <div className="col-auto">
              <Breadcrumb>
                <BreadcrumbItem active>Allocation</BreadcrumbItem>
                <BreadcrumbItem><Link to='/portfolio/tactical/funds'>Selección de Fondos</Link></BreadcrumbItem>
              </Breadcrumb>
            </div>
          </div>
          <div className='row justify-content-center align-items-end m-5'>
            <div className='col-4'>
              <CustomListSelect
                options={this.props.user_wm.data.ports_list}
                isClearable={true}
                value={this.props.tactical_params.port_name==null ? null : {value:this.props.tactical_params.port_name, label:this.props.tactical_params.port_name}}
                onChange={(e)=>this.props.changeModel("tactical_params.port_name", e==null ? null : e.value)}
                itemSize={50}
                className="basic-single"
                placeholder="seleccionar portafolio"
              />
            </div>
            <div className='col-auto'>
                {this.state.loading_portfolio ?
                <CustomLoading msg="cargando portafolio"/>
                :
                <Button 
                    className="btn-corp"
                    onClick={this.queryPortfolio}>
                    Consultar Portafolio
                </Button>
                  
                }
            </div>
          </div>
        </>
        );
    }
    addTrade = async (e) => {
      e.preventDefault();
      const form = e.target;
      if (this.state.fund_sel_ow==null && this.state.fund_sel_uw==null){
        this.setState({msg:"Seleccionar fondo!"});
      } else if (form.weight.value=='' || form.weight.value==null || form.weight.value==0){
        this.setState({msg:"Porcentaje de desviación inválida!"});
      } else if (this.state.fund_sel_uw!=null && this.state.fund_sel_uw!=="" && (this.props.tactical_params.port.find(k=>k.Asset==this.state.fund_sel_uw).Weight+(this.props.tactical_params.trades.find(k=>k.Asset==this.state.fund_sel_uw)?.Weight || 0))<form.weight.value){
        this.setState({msg:"No es posible subponderar la desviación insertada!"});
      } else {
          this.props.changeModel('tactical_params.trades', 
            aggregate([
              ...(this.state.fund_sel_ow!=='' && this.state.fund_sel_ow!=null ?
                [{
                  Asset:this.state.fund_sel_ow, 
                  Weight:parseFloat(form.weight.value.replace(/,/g, ''))
                }] : []),
              ...(this.state.fund_sel_uw!=='' && this.state.fund_sel_uw!=null ?
                [{
                  Asset:this.state.fund_sel_uw, 
                  Weight:-parseFloat(form.weight.value.replace(/,/g, ''))
                }] : []),
              ...this.props.tactical_params.trades
            ], ["Asset"], ["Weight"]));
        this.setState({msg:null});
      }
    };
  resetTrades(){
    this.props.changeModel('tactical_params.trades', []);
  }

  async sendTrades(){
    if (this.props.tactical_params.trades.length==0) {
      this.setState({msg:"No se han insertado operaciones."});
    } else {
      const port_metrics_tac = await this.props.fetchData(
        { 
          port:aggregate([...this.props.tactical_params.trades, ...this.props.tactical_params.port], ['Asset'], ['Weight']).map(item=>{
            return {name:item.Asset, value:item.Weight};
          }), 
          bench:this.props.tactical_params.port_name,
          ref_curr:this.props.tactical_params.ref_curr,
          ini_date:this.props.tactical_params.ini_date,
        }, 'port_metrics_wm', port_tactical_actions, 1, ["rets_summ", "series", "names"]
      );
    }
  }

  render() {
      if(this.props.user_wm.isLogging){
        return(
          <div className='container'>
            <div className="row justify-content-center">
                <Loading />
            </div>
          </div>
        );
      } else if (this.props.tactical_params.port==null && this.props.port_metrics_tactical.data==null){
          return(
            <div className='container'>
              {this.header()}
              <div className="row mt-4 justify-content-center">
                <div className="col-4 m-3">
                  <Alert
                    color='secondary'
                    isOpen={this.state.msg!=='' && this.state.msg!==null} 
                    toggle={()=>this.setState({msg:null})}
                    fade={false}>
                      {this.state.msg}
                  </Alert>
                </div>
              </div>
              <div className="row justify-content-center m-5">
                <h6>No hay datos disponibles.</h6>
              </div>
            </div>
          );
      } else {
        const port_saa_adjust = this.props.tactical_params.trades.length==0 ? null :
          add_perc_key(aggregate([...this.props.tactical_params.trades, ...this.props.tactical_params.port], ['Asset'], ['Weight']), "Weight").map(item=>{
            return {Asset:item.Asset, Weight:item.percentage};
          });

        const port_saa = port_saa_adjust==null ? 
          this.props.tactical_params.port.map(item=>{
            return {Asset:item.Asset, Portafolio:item.Weight};
          }).sort(sort_by('Portafolio'))
          : port_saa_adjust.map(item=>{
            return {Asset:item.Asset, Portafolio:this.props.tactical_params.port.filter(port=>port.Asset==item.Asset).length==0 ? 0 : this.props.tactical_params.port.find(port=>port.Asset==item.Asset).Weight, 
            Ajustado:item.Weight};
          }).sort(sort_by('Portafolio'));

        const port_dev = port_saa_adjust==null 
          ? this.props.tactical_params.port.map(item=>{
            return {Asset:item.Asset, Delta:0};
          })
          : port_saa_adjust.map(item=>{
            return {Asset:item.Asset, Delta:Math.round((item.Weight - (this.props.tactical_params.port.filter(port=>port.Asset==item.Asset).length==0 ? 0 : this.props.tactical_params.port.filter(port=>port.Asset==item.Asset)[0].Weight))*10)/10};
          }).sort(sort_by('Delta'));

        const risk_compar = this.props.port_metrics_tactical.data==null ? null : this.props.port_metrics_tactical.data.rets_summ.map(item=>{
          return {'Métrica':item['Métrica'], 
                  Benchmark:item.Benchmark,
                  'Portafolio Ajustado':item.Portafolio};
        });
        const fund_options = this.props.user_wm.data.assets.sort(sort_by("Asset"))
                              .map(x=>{return({value:x.Asset, label:x.Asset})});

        return (
          <div className="container">
            {this.header()}
            <Modal isOpen={this.state.load_portfolio} toggle={()=>this.setState({load_portfolio:!this.state.load_portfolio})}>
              <ModalHeader toggle={()=>this.setState({load_portfolio:!this.state.load_portfolio})}>Guardar Portafolio</ModalHeader>
              <ModalBody>
                <div className="row mt-4 justify-content-center">
                  <div className="col m-3">
                    <h6>{`Se va a guardar un nuevo portafolio táctico con nombre ${this.props.tactical_params.port_name.includes("Tactico") ? this.props.tactical_params.port_name : this.props.tactical_params.port_name + " - Tactico"}. ¿Está seguro?`}</h6>
                  </div>
                </div>
                <div className="row mt-2 justify-content-center">
                  <div className="col-8">
                    <Alert
                      color='secondary'
                      isOpen={this.state.msg_save!=='' && this.state.msg_save!==null} 
                      toggle={()=>this.setState({msg_save:null})}
                      fade={false}
                      >
                        {this.state.msg_save}
                    </Alert>
                  </div>
                </div>
                <div className="row m-1 justify-content-center">
                  {this.state.saving_portfolio ?
                    <div className='col-auto'>
                      <CustomLoading msg="guardando"/>
                    </div>
                  : 
                  <>
                    <div className="col-auto m-1">
                      <Button 
                        onClick={this.savePortfolio}
                        className="btn-corp">
                          Sí, guardar
                      </Button>
                    </div>
                    <div className="col-auto m-1">
                      <Button 
                        onClick={()=>this.setState({load_portfolio:false})}
                        className="btn-corp">
                          Cancelar
                      </Button>
                    </div>
                  </>
                  }
                </div>
              </ModalBody>  
            </Modal>

            <div className="row mt-4 justify-content-center">
              <div className="col-4 m-3">
                <Alert
                  color='secondary'
                  isOpen={this.state.msg!=='' && this.state.msg!==null} 
                  toggle={()=>this.setState({msg:null})}
                  fade={false}
                  >
                    {this.state.msg}
                </Alert>
              </div>
            </div>
            <div className="row mt-2 justify-content-center">
              <div className='col' id="dev">
                <h5>Desviación de <i>Allocation</i></h5>
                {risk_compar!==null ? <a className='linkcol' href='#risk'>riesgo&darr;</a> : null}
              </div>
            </div>
            <Form onSubmit={this.addTrade}>
              <div className="row m-4 justify-content-center align-items-start">
                <div className='col-3'>
                  <Label>Sobreponderar</Label>
                  <CustomListSelect
                    className="basic-single"
                    options={fund_options}
                    value={{value:this.state.fund_sel_ow, label:this.state.fund_sel_ow}}
                    onChange={(e)=>this.setState({fund_sel_ow:e?.value})}
                    itemSize={60}
                    isClearable={true}
                    isSearchable={true}
                    placeholder="seleccionar fondo..."
                  />
                </div>
                <div className='col-3'>
                  <Label>Subponderar</Label>
                  <CustomListSelect
                    className="basic-single"
                    options={this.props.tactical_params.port.map(k=>{
                      return {label:k.Asset, value:k.Asset}
                    })}
                    value={{value:this.state.fund_sel_uw, label:this.state.fund_sel_uw}}
                    onChange={(e)=>this.setState({fund_sel_uw:e?.value})}
                    itemSize={60}
                    isClearable={true}
                    isSearchable={true}
                    placeholder="seleccionar fondo..."
                  />
                </div>

                <div className='col-1'>
                  <FormGroup>
                    <Label for='weight'>Desviación</Label>
                    <Input
                      id='weight'
                      type='text'
                      onChange={this.handleNumericInput}
                      placeholder="%..."
                    >
                    </Input>
                  </FormGroup>
                </div>
              </div>
              <div className="row m-2 justify-content-center align-items-end">
                <div className='col-auto'>
                  <Button 
                    type='submit'
                    className='btn-corp'>
                    Agregar
                  </Button>
                </div>
                <div className='col-auto'>
                  <Button 
                    onClick={this.resetTrades}
                    className='btn-corp'>
                    Reset
                  </Button>
                </div>
                <div className='col-auto'>
                  <Button 
                    onClick={this.openSaveModal}
                    className='btn-corp'>
                    Guardar Portafolio Táctico
                  </Button>
                </div>
              </div>
            </Form>
            {this.props.tactical_params.trades.length>0 ?
            <>
              <div className="row mt-5 justify-content-center">
                <div className='col-auto'>
                  <h6>Desviaciones</h6>
                  <RenderVirtualTable 
                    data={this.props.tactical_params.trades.map(({Asset, Weight})=>({Asset, Weight}))} 
                    to_perc={[false, true]}
                    cell_width={["250px", '150px', '150px']}
                    item_size={30}
                    style="black"
                    />
                </div>
              </div>
              <ReduxForm model="tactical_params">
                <div className='row mb-2 justify-content-center align-items-end'>
                    <div className='col-1'>
                        <label htmlFor=".ref_curr"><small>Moneda</small></label>
                        <Control.select 
                            model=".ref_curr" 
                            type="select" 
                            name="ref_curr"
                            className="form-control"
                            disabled={false}
                            >
                            <option>USD</option>
                            <option>CLP</option>
                            <option>CLF</option>
                            <option>MXN</option>
                            <option>COP</option>
                            <option>PEN</option>
                            <option>UYU</option>
                        </Control.select>
                    </div>
                    <div className='col-2'>
                        <label htmlFor=".ini_date"><small>Fecha Inicial</small></label>
                        <Control.text model=".ini_date" type="date"
                            name="ini_date"
                            dafaultvalue="2011-01-01"
                            dateform="YYYY-MM-DD"
                            className="form-control"
                            updateOn='blur'
                            disabled={false}
                        />
                    </div>
                    <div className='col-2'>
                        <label htmlFor=".ref_date"><small>Fecha Final</small></label>
                        <Control.text model=".ref_date" type="date"
                            name="ref_date"
                            dateform="YYYY-MM-DD"
                            className="form-control"
                            updateOn='blur'
                            disabled={false}
                        />
                    </div>
                    <div className='col-auto'>
                      <Button 
                        onClick={this.sendTrades}
                        className='btn-corp'>
                        Actualizar Métricas
                      </Button>
                    </div>
                </div>
              </ReduxForm>
            </>
            : null
            }
            {port_saa!==null && port_saa.length>0 ?
            <>
              <div className="row m-4 justify-content-center">
                <div className='col-8'>
                  <hr></hr>
                </div>
              </div>
              <div className="row m-4 justify-content-center align-items-center">
                <div className='col-md-6'>
                  <h6>Portafolio</h6>
                  <MultBarPlot 
                    data={port_saa}
                    nameKey='Asset'
                    vertical={true}
                    angle={0}
                    ytype="category" xtype="number"
                    colors={["#000000", "#1215E3"]}
                    xpercAxis={true}
                    percTooltip={true}
                    width={500}
                    interval={0}
                    height={400}
                    barsize={10}
                    legend={port_saa_adjust!==null ? true : false}
                    fontsize={12}
                  />
                </div>
                <div className='col-md-6'>
                  <h6>Desviación</h6>
                  <BarPlot 
                    x={port_dev.map(k=>k.Delta)}
                    y={port_dev.map(k=>k.Asset)}
                    nameKey='Asset'
                    layout={"vertical"}
                    angle={0}
                    ytype="category" xtype="number"
                    color={"#000000"}
                    colorNeg={"#1215E3"}
                    xpercAxis={true}
                    percTooltip={true}
                    width={500}
                    interval={0}
                    height={400}
                    barsize={10}
                    legend={false}
                    fontsize={12}
                  />
                </div>
              </div>
            </>
            :null              
            }
            {this.props.port_metrics_tactical.isLoading ?
            <>
              <div className="row m-5 justify-content-center">
                <div className='col-12'>
                  <hr></hr>
                </div>
              </div>
              <div className="row m-3 justify-content-center">
                <div className='col-auto'>
                  <h6>Riesgo</h6>
                </div>
              </div>
              <div className="row m-5 justify-content-center">
                <div className='col-auto'>
                  <CustomLoading msg="calculando métricas" icon="fa-calculator"/>
                </div>
              </div>
            </>
            : this.props.port_metrics_tactical?.errMess ?
            <>
              <div className="row m-5 justify-content-center">
                <div className='col-12'>
                  <hr></hr>
                </div>
              </div>
              <div className="row m-3 justify-content-center">
                <div className='col-auto'>
                  <h6>Riesgo</h6>
                </div>
              </div>
              <div className="row mt-4 justify-content-center">
                <div className="col-4 m-3">
                  <Alert
                    color='danger'
                    isOpen={this.props.port_metrics_tactical.errMess!=='' && this.props.port_metrics_tactical.errMess!==null} 
                    toggle={()=>this.changeModel("port_metrics_tactical.errMess", null)}
                    fade={false}>
                      {this.props.port_metrics_tactical.errMess}
                  </Alert>
                </div>
              </div>
            </>
            : risk_compar!==null ?
            <>
              <div className="row m-5 justify-content-center">
                <div className='col-12'>
                  <hr></hr>
                </div>
              </div>
              <div className="row mt-3 justify-content-center">
                <div className='col-auto' id="risk">
                  <h5>Riesgo</h5>
                  <p>{this.props.port_metrics_tactical.data.series[0].Date} / {this.props.port_metrics_tactical.data.series.slice(-1)[0].Date}</p>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className='col-auto'>
                  <a className='linkcol' href='#dev'>volver&uarr;</a>
                </div>
              </div>
              <div className="row m-3 justify-content-center">
                <div className='col-6'>
                  <div className="row justify-content-center">
                    <div className='col-auto'>
                      <RenderVirtualTable 
                        data={risk_compar} 
                        to_perc={[false, true, true, true]}
                        to_perc_row={[true, true, true, true, false, true, false, false, false]}
                        cell_width={['200px', "100px", '100px']}
                        item_size={30}
                        />
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className="row justify-content-center">
                    <div className='col-auto'>
                      <ButtonGroup size='sm'>
                        <Button
                          color="dark"
                          outline
                          onClick={() => this.setState({show_series:!this.state.show_series})}
                          active={this.state.show_series}
                        >
                          series
                        </Button>
                        <Button
                          color="dark"
                          outline
                          onClick={() => this.setState({show_series:!this.state.show_series})}
                          active={!this.state.show_series}
                        >
                          riesgo-retorno
                        </Button>
                      </ButtonGroup>
                    </div>
                  </div>
                  <div className="row justify-content-start">
                    {this.state.show_series ?
                      <div className='col-auto'>
                        <MultLineTsPlot 
                          data={this.props.port_metrics_tactical.data.series}
                          width={600}
                          height={450}
                          xkey='Date'
                          ykeys={this.props.port_metrics_tactical.data.names}
                          xtype='category'
                          ytype='number'
                          colors = {colors_sura}
                          percTooltip={false}
                          legend={true}
                          ml={100}
                          mr={100}
                        />
                      </div>
                    : risk_compar.find(k=>k["Métrica"]=="Volatilidad Anual.").Benchmark!=="" ?
                      <div className='col-6'>
                        <ScatterPlot
                          data={transpose(risk_compar, "Métrica", "Portafolio")}
                          color="#000000"
                          xlabel="Volatilidad"
                          ylabel="Retorno Promedio"
                          xAxisId="Volatilidad Anual."
                          yAxisId="Retorno Promedio Anual."
                          zAxisId='Portafolio'
                          dataName='Portafolios'
                          percTooltip={true}
                          width={500}
                          height={450}
                          right={0}
                          xpercAxis={true}
                          ypercAxis={true}
                          legend={false}
                          labelKey={"Portafolio"}
                          showLabels={true}
                        />
                      </div>
                      :
                      <div className='col-6 m-5'>
                        <h6>No hay datos disponibles.</h6>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </>
            :null
            }

          </div>
        );
      }
    }
}
//export default Port;
export default withRouter(connect(mapStateToProps)(PortTactical));